import dashboard from './dashboard';
// import widget from './widget';
import application from './application';

import cours from './cours';
import ConfigPaiements from './paiements/ConfigPaiements';
import etudiants from './etudiants';
import caisse from './caisse';
import professeurs from './professeurs';
import candidatures from './candidatures';
import formulesPoints from './formulesPoints';
import deliberations from './deliberations';
import pointsEnregistrements from './pointsEnregistrements';
import emailNotifications from './emailNotifications';
import resourcesHumaines from './resourcesHumaines';


// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [
        dashboard, 
        application, 
        emailNotifications, 
        cours, 
        formulesPoints, 
        deliberations, 
        ConfigPaiements, 
        caisse, 
        etudiants,
         professeurs, 
        pointsEnregistrements, 
        candidatures,
        resourcesHumaines]
};

export default menuItems;
